import {ReactComponent as LogoImg} from "../../assets/images/logo_payoff.svg";

function Logo() {
  return (
        <LogoImg width={200}/>
  )
}

export default Logo;
